import s from './style.module.scss';
import { Input } from 'antd';
import { useState } from 'react';
const { TextArea } = Input;
const GrtTextArea = (props) => {
    const { onFocus, onBlur, ...params } = props;
    const [inFocus, setInFocus] = useState(false);
    const focus = (e) => {
        setInFocus(true);
        if (onFocus) {
            onFocus(e);
        }
    };
    const blur = (e) => {
        setInFocus(false);

        if (onBlur) {
            onBlur(e);
        }
    };
    return (
        <div data-focus={inFocus} data-disabled={params.disabled} className={s['text-area-wrap']}>
            <TextArea onFocus={focus} onBlur={blur} {...params} />
        </div>
    );
};
export default GrtTextArea;
